import { fetchFeatureFlags } from '@/features/shared/services/FeatureFlags/fetchers'
import { queryOptions } from '@tanstack/react-query'

export const featureFlagsQueryOptions = ({ userId }: { userId: number }) =>
  queryOptions({
    queryKey: ['featureFlags', userId] as const,
    queryFn: fetchFeatureFlags,
    // we don't want featureflags to refetch during a user session, so that we maintain a consistent user experience during a session
    staleTime: Infinity,
  })
